/* eslint-disable no-param-reassign */
import { api } from "jiffy-api";
import { track } from "jiffy-analytics";
import { redirectTo } from "common/utils/browser";
import "./same-day-delivery-checker.scss";

const CLASSES = {
  HIDDEN: "hidden",
  CHECKER: {
    EMPTY: "same-day-delivery-checker--success"
  },
  MESSAGE: {
    SUCCESS: "same-day-delivery-checker__message--success",
    ERROR: "same-day-delivery-checker__message--error"
  }
};

class SameDayDeliveryChecker {
  constructor(options) {
    this.options = options;
    this.init();
  }

  init() {
    this.handleSubmit = this.handleSubmit.bind(this);

    if (this.$form) {
      this.getFlashCommonDates();
      this.$form.addEventListener("submit", this.handleSubmit);

      if (!this.zipcode) {
        this.$form.classList.add(CLASSES.CHECKER.EMPTY);
      }
    }
  }

  get $action() {
    return document.querySelector(this.options.actionSelector);
  }

  get $form() {
    return document.querySelector(this.options.formSelector);
  }

  get $message() {
    return document.querySelector(this.options.messageSelector);
  }

  get $loader() {
    return document.querySelector(this.options.loaderSelector);
  }

  get $title() {
    return document.querySelector(this.options.titleSelector);
  }

  get $timer() {
    return document.querySelector(this.options.timerSelector);
  }

  get $skepeletonLoader() {
    return document.querySelectorAll(this.options.waveSelector);
  }

  get zipcode() {
    return new FormData(this.$form).get("zip");
  }

  get redirectToUrl() {
    return this.$form.dataset.redirectTo;
  }

  set message(value) {
    if (value && this.$message) {
      const isError = value.type === "error";

      this.$message.classList.remove(CLASSES.HIDDEN);
      this.$message.innerHTML = value.text;

      this.$message.classList.toggle(CLASSES.MESSAGE.SUCCESS, !isError);
      this.$message.classList.toggle(CLASSES.MESSAGE.ERROR, isError);
    } else if (this.$message) {
      this.$message.classList.add(CLASSES.HIDDEN);
    }
  }

  set isLoading(value) {
    this.$skepeletonLoader.forEach($wave => {
      $wave.dataset.loading = value;
    });
  }

  set isFormLoading(value) {
    if (value) {
      this.$form.classList.remove(CLASSES.CHECKER.EMPTY);
      this.$loader.classList.remove(CLASSES.HIDDEN);
      this.$action.disabled = true;
    } else {
      this.$loader.classList.add(CLASSES.HIDDEN);
      this.$action.disabled = false;
    }
  }

  $getMessageTemplate(type) {
    const selector = `${this.options.messageTemplateSelector}[data-message-template="${type}"]`;
    const $template = document.querySelector(selector);
    return $template && $template.cloneNode(true);
  }

  async getFlashCommonDates() {
    try {
      this.isLoading = true;
      const { estimates, success } = await api.product.fetchFlashCommonDates();
      this.isLoading = false;

      if (!success) {
        this.message = {
          text: "Something went wrong...",
          type: "error"
        };

        return;
      }

      this.renderFlashCommonDates(estimates);
      this.renderFlashCommonMessage(estimates.status);
    } catch (error) {
      this.isLoading = false;
      this.message = {
        text: error.message || "Something went wrong...",
        type: "error"
      };
    }
  }

  renderFlashCommonDates({ date, delivery_endtime: deliveryEndtime }) {
    this.$title.innerHTML = date;
    this.$timer.dataset.countdown = deliveryEndtime;
  }

  renderFlashCommonMessage(status) {
    const $messageTemplate = this.$getMessageTemplate(status);
    if ($messageTemplate) {
      $messageTemplate.classList.remove(CLASSES.HIDDEN);
      this.$message.appendChild($messageTemplate);
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    try {
      this.message = null;
      this.isFormLoading = true;

      track("flash_plp_zipcode_entered", { zip_code: this.zipcode });

      const { error, message: errorMessage } = await api.location.update({
        zipcode: this.zipcode
      });

      if (error) {
        this.isFormLoading = false;
        this.message = {
          text: errorMessage || "Please enter a valid zipcode",
          type: "error"
        };
      } else {
        redirectTo(this.redirectToUrl);
      }
    } catch (error) {
      this.isFormLoading = false;
      this.message = {
        text: error.message || "Something went wrong...",
        type: "error"
      };
    }
  }
}

const init = () =>
  new SameDayDeliveryChecker({
    actionSelector: ".js-same-day-delivery-checker-action",
    formSelector: ".js-same-day-delivery-checker",
    loaderSelector: ".js-same-day-delivery-checker-loader",
    messageSelector: ".js-same-day-delivery-checker-message",
    messageTemplateSelector: ".js-same-day-delivery-checker-message-template",
    timerSelector: ".js-same-day-delivery-checker-timer",
    titleSelector: ".js-same-day-delivery-checker-title",
    waveSelector: ".js-same-day-delivery-checker [data-loading]"
  });

export default init;
